import { buttonVariants } from 'components/ui/button';
import { ClipboardCheck } from 'lucide-react';
import { isDev } from 'config';
import { useAppSelector } from 'hooks';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AuditsContainer() {
  const { t } = useTranslation();
  const groupIds = isDev
    ? ['98gXbL6kxlaDmMMGjBdw']
    : [
        'RuXfdQ77eGHqAsQSHK5m',
        'szGrXKI9MAya8vPFG3wT',
        'Gua3ROcmn9CBLIGSpOVn',
        '46zYSYgrJQ68tjYqMhSe',
      ];
  const orgs = useAppSelector((state) =>
    state.orgs.orgs.filter((org) => org.groupId && groupIds.includes(org.groupId))
  );

  const rgsOnly = orgs.some((org) => org.groupId && groupIds.includes(org.groupId));

  if (!rgsOnly) return null;
  return (
    <NavLink
      className={`${buttonVariants({
        variant: 'ghost',
        size: 'sm',
      })} !text-muted-foreground hover:!text-foreground`}
      activeClassName="!bg-secondary !text-foreground"
      to="/internal-audit"
    >
      <ClipboardCheck aria-hidden="true" />
      {t('header.audits')}
    </NavLink>
  );
}
